import HomePage from 'views/Home/Home'

var publicRoutes = [{ path: '/', name: 'Página Inicial', component: HomePage }]

export default publicRoutes
